import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'so0016',
    ecrans: ['00-2']
});
